<template>
    <a :href="externalHref" :target="hrefTarget" v-if="externalHref != null">
        <slot></slot>
    </a>
</template>
<script>

export default {
    data () {
        return {
            externalHref: null,
            hrefTarget: "_self"
        };
    },
    props: {
        href: Object,
        target: {
            type: String,
            default: "_self"
        }
    },
    watch: {
        href (v) {
            this.href = v;
        },
        target (v) {
            this.hrefTarget = v;
        }
    },
    mounted () {
        this.externalHref = this.href;
        this.hrefTarget = this.target;
    }
}
</script>